import { BlocksIconCancel } from 'blocks-nextjs/blocks-web-components/components/icon/icons/cancel';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCancel = createComponent({ react: React, tagName: 'cat-icon-cancel', elementClass: BlocksIconCancel });
